import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


import { MainRoutingModule } from './main-routing.module';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { HomeComponent } from '../home/home.component';
import { AboutComponent } from '../about/about.component';
import { LoginComponent } from '../auth/login/login.component';
import { SignupComponent } from '../auth/signup/signup.component';
import { AddBlogComponent } from '../admin/add-blog/add-blog.component';
import { BlogsListComponent } from '../blogs/blogs-list/blogs-list.component';
import { ArchivalComponent } from '../blogs/archival/archival.component';
import { SafehtmlPipe } from '../pipes/safehtml.pipe';
import { ContactComponent } from '../contact/contact.component';
import { MainComponent } from './main.component';
import { AddLessonComponent } from '../admin/add-lesson/add-lesson.component';
import { AddCourseComponent } from '../admin/add-course/add-course.component';
import { AddModuleComponent } from '../admin/add-module/add-module.component';
import { CourseWizardComponent } from '../admin/course-wizard/course-wizard.component';
import { CourseListComponent } from '../courses/course-list/course-list.component';
import { CourseDetailsComponent } from '../courses/course-details/course-details.component';
import { CategoryComponent } from '../courses/category/category.component';
import { CoursePlayComponent } from '../courses/course-play/course-play.component';
import { DashboardComponent } from '../users/dashboard/dashboard.component';
import { AccountComponent } from '../users/account/account.component';
import { ScoresComponent } from '../users/scores/scores.component';
import { SettingsComponent } from '../users/settings/settings.component';
import { MyCoursesComponent } from '../users/my-courses/my-courses.component';
import { CartComponent } from '../cart/cart.component';
import { ErrorComponent } from '../shared/error/error.component';
import { SignupSuccessComponent } from '../shared/signup-success/signup-success.component';
import { StudentManagementComponent } from '../admin/student-management/student-management.component';
import { AddQuizComponent } from '../admin/add-quiz/add-quiz.component';
import { ViewQuizComponent } from '../courses/view-quiz/view-quiz.component';
import { UserInfoComponent } from '../users/user-info/user-info.component';
import { FeedbackComponent } from '../courses/feedback/feedback.component';
import { PaymentComponent } from '../payment/payment.component';
import { TickerTapeComponent } from '../shared/ticker-tape/ticker-tape.component';
import { AnnouncementViewComponent } from '../announcement-view/announcement-view.component';
@NgModule({
  declarations: [
    MainComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    AboutComponent,
    LoginComponent,
    SignupComponent,
    AddBlogComponent,
    BlogsListComponent,
    ArchivalComponent,
    SafehtmlPipe,
    ContactComponent,
    AddLessonComponent,
    AddCourseComponent,
    AddModuleComponent,
    CourseWizardComponent,
    CourseListComponent,
    CourseDetailsComponent,
    CategoryComponent,
    CoursePlayComponent,
    DashboardComponent,
    AccountComponent,
    ScoresComponent,
    SettingsComponent,
    MyCoursesComponent,
    CartComponent,
    ErrorComponent,
    SignupSuccessComponent,
    StudentManagementComponent,
    AddQuizComponent,
    ViewQuizComponent,
    UserInfoComponent,
    FeedbackComponent,
    PaymentComponent,
    TickerTapeComponent,
    AnnouncementViewComponent
  ],
  imports: [
    CommonModule,
    MainRoutingModule,
    ReactiveFormsModule,
    FormsModule,

  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    AboutComponent,
    LoginComponent,
    SignupComponent,
    AddBlogComponent,
    BlogsListComponent,
    ArchivalComponent,
    SafehtmlPipe,
    ContactComponent,
    CategoryComponent,
    TickerTapeComponent,
    AnnouncementViewComponent
  ]
})
export class MainModule { }
